import { ActionDescriptor } from '../common/commonTypes';
import RelateAttributeForm from './RelateAttributeForm';

const relateAttribute: ActionDescriptor = {
	FormComponent: RelateAttributeForm,
	actionTitle: 'Relate',
};

export default relateAttribute;
